import { render } from "./EditRebate.vue?vue&type=template&id=0da02c96&scoped=true"
import script from "./EditRebate.vue?vue&type=script&lang=js"
export * from "./EditRebate.vue?vue&type=script&lang=js"

import "./EditRebate.vue?vue&type=style&index=0&id=0da02c96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da02c96"]])

export default __exports__